<div class="SAS_Navbar">
  <!-- Header -->
  <app-outer-pages-header></app-outer-pages-header>

  <div class="intro2">
    <div class="container">
      <div class="my-5">
        <div class="articleHeader">
          <h1 style="font-weight: bold">{{ news.title }}</h1>
          <div class="time icon-time" style="color: #9da4ae">
            <span> {{ currentDate }} </span>
          </div>
        </div>

        <div class="img mt-3">
          <img
            class="news-img"
            src="{{ news.pictureUrl }}"
            style="max-height: 400px; width: 100%"
            alt="Card image cap"
          />
        </div>

        <div class="mt-4 width-60">
          <p
            class="pt-2 font-weight-n font-size-20 color-dark-gray"
            style="color: #4d5761"
          >
            {{ news.description }}
          </p>
        </div>

        <!-- <div *ngIf="news.id == 4 && news.special == true">
          <div class="row">
            <div class="col-lg-4 col-sm-12 box-edit">
              <div class="footer-links">
                <ul class="sm-links w-list list-box pr-3">
                  <li class="row">
                    <div class="col-sm-2">
                      <i
                        class="fas fa-map-marker-alt fa-2x icon-edit text-red"
                      ></i>
                    </div>

                    <div class="col-sm-8">
                      <p class="font-size-22 mb-1 color-dark-gray">الموقع</p>
                      <a class="text-muted font-size-14">
                        6868, طريق أبو هريرة , حى المروج , 5473 , الرمز البريديى
                        62527 مدينة أبها.</a
                      >
                    </div>
                  </li>

                  <li class="row">
                    <div class="col-sm-2">
                      <i
                        class="far fa-envelope fa-2x icon-edit text-yellow"
                      ></i>
                    </div>

                    <div class="col-sm-8">
                      <p class="font-size-22 mb-1 color-dark-gray">
                        البريد الإلكترونى
                      </p>
                      <a
                        href="mailto:info@mcsc.sa"
                        class="text-muted font-size-14"
                        target="_blank"
                      >
                        info@mcsc.sa
                      </a>
                    </div>
                  </li>

                  <li class="row">
                    <div class="col-sm-2">
                      <i class="fas fa-phone fa-2x icon-edit"></i>
                    </div>

                    <div class="col-sm-8">
                      <p class="font-size-22 mb-1 color-dark-gray">الهاتف</p>
                      <a
                        href="tel:9660172660007"
                        class="text-muted font-size-14"
                        target="_blank"
                        dir="ltr"
                        lang="en"
                      >
                        966 + (0) 17 266 0007
                      </a>
                    </div>
                  </li>

                  <li class="row">
                    <div class="col-sm-2">
                      <i class="fab fa-whatsapp fa-2x icon-edit text-green"></i>
                    </div>

                    <div class="col-sm-8">
                      <p class="font-size-22 mb-1 color-dark-gray">واتس أب</p>
                      <a
                        href="https://wa.me/966557266007"
                        class="text-muted font-size-14"
                        target="_blank"
                        dir="ltr"
                        lang="en"
                      >
                        055 7266 007
                      </a>
                    </div>
                  </li>
                </ul>
              </div>
            </div>

            <div class="col-lg-8 col-sm-12">
          
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3254.4689299000984!2d42.560554993904695!3d18.211139139105846!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x9197b7c2096022fe!2z2YXYsdmD2LIg2K3ZhNmI2YQg2KfZhNiq2YjYp9i12YQg2YTYo9mF2LHYp9i2INin2YTYs9mF2Lkg2YjYp9mE2KrYrtin2LfYqA!5e1!3m2!1sen!2sus!4v1650555159650!5m2!1sen!2sus"
                width="100%"
                height="450"
                style="border-radius: 6px; border: none"
                allowfullscreen=""
                loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </div>
        </div> -->
      </div>
    </div>
  </div>

  <!-- Footer -->
  <app-outer-pages-footer></app-outer-pages-footer>
</div>
